import type {StateProvider} from '@uirouter/angularjs';
import KpLocalizationsComponent from './kp-localizations.component';

/*@ngInject*/
export default function utilRoutes($stateProvider: StateProvider) {

    $stateProvider
        .state({
            name: 'localizations',
            url: '/localizations',
            component: KpLocalizationsComponent.componentName,
            
        });
}